export const SKUREGEX = /^[A-Z0-9]+-[A-Z0-9]+-[A-Z0-9]+$/i
